/*
 * Copyright (C) Luna Srl - All Rights Reserved
 *
 * @project    bfree-frontend.nosync
 * @file       TextInputBlockWithButton.tsx
 * @author     Christian Ascone
 * @date       10/31/19 10:26 AM
 */

import React from 'react';
import {TextInput, View} from 'react-native';
import TextStyle from '@styles/TextStyle';
import buttonStyle from '@styles/ButtonStyle';
import {AvenirBookUpperLabelText} from "./StyledText";
import {ConfirmButton} from "./ConfirmButton";

export function TextInputBlockWithButton(props) {
    return (
        <View style={buttonStyle.inputBlockButtonContainer}>
            <View style={buttonStyle.inputBlockButtonInputContainer}>
                <AvenirBookUpperLabelText>
                    {props.label}
                </AvenirBookUpperLabelText>
                <TextInput
                    keyboardType={props.keyboardType}
                    style={[props.style, TextStyle.separator]}
                    secureTextEntry={props.secureTextEntry}
                    placeholder={props.placeholder || props.label}
                    onChangeText={props.onChangeText}
                    value={props.text}
                />
            </View>
            <View style={buttonStyle.inputBlockButtonButtonContainer}>
                <ConfirmButton active={props.active} onPress={props.onPress} title={props.buttonTitle}
                               style={{margin: 0, paddingTop: 0, paddingBottom: 0}}/>
            </View>
        </View>
    );
}
